export const presistDataTypes = {
  PRESIST_DATA: 'PRESIST_DATA',
  FETCH_MY_ORDERS: 'FETCH_MY_ORDERS',
};
